import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';

export const StyledFormControlLabel = styled(FormControlLabel)({
  justifyContent: 'space-between',
  margin: 0
});



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpHookFormSwitch/styles.js